<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  @import "scss/common.css";

  @font-face {
    font-family: 'pingfang';
    src: url("~@/assets/font/PingFangRegular.ttf") format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  .dialogSel_obj{
    .el-select-dropdown__item{
      span{
        font-family: 'pingfang';
      }
    }
  }
  #app {
    font-family: 'pingfang';
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }
  body {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue